import { render, staticRenderFns } from "./GiveSuccess.vue?vue&type=template&id=ffcbdafc&scoped=true&lang=html"
import script from "./GiveSuccess.vue?vue&type=script&lang=js"
export * from "./GiveSuccess.vue?vue&type=script&lang=js"
import style0 from "./GiveSuccess.vue?vue&type=style&index=0&id=ffcbdafc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcbdafc",
  null
  
)

export default component.exports